module.exports = __webpack_public_path__ + "img/youhuiq.07c0dda7.png";